import request from '@/utils/request'
// 公众号音频文本模板创建
export function addTextVoice(data) {
  return request({
    url: '/officialAccount/addTextVoice',
    method: 'post',
    data
  })
}

// 公众号音频文本模板修改
export function updateTextVoice(data) {
  return request({
    url: '/officialAccount/updateTextVoice',
    method: 'post',
    data
  })
}

// 小程序列表
export function programList(params = {}) {
  return request({
    url: '/spWorkWechat/applet/index',
    method: 'get',
    params
  })
}

// 添加小程序
export function addProgram(data) {
  return request({
    url: '/spWorkWechat/applet/store',
    method: 'post',
    data
  })
}

// 编辑小程序
export function updateProgram(data) {
  return request({
    url: '/spWorkWechat/applet/update',
    method: 'post',
    data
  })
}

// 删除小程序
export function deleteProgram(data) {
  return request({
    url: '/spWorkWechat/applet/delete',
    method: 'post',
    data
  })
}
// 获取可设置的登录版本号
export function getUpPlusWwVersion(params = {}) {
  return request({
    url: '/spWorkWechat/spCorp/getUpPlusWwVersion',
    method: 'get',
    params
  })
}
// 设置可登录的版本号
export function setUpPlusWwVersion(data) {
  return request({
    url: '/spWorkWechat/spCorp/setUpPlusWwVersion',
    method: 'post',
    data
  })
}
